export const NATIONAL_SCOPE = 'national'
